import comp from "./SelectResourceDialogue";
export default comp;
